import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { hasSession } from '../auth/oidc';
import { isOidcConfigured } from '../config';

export default function PrivateRoutes() {
  const location = useLocation();

  // While OIDC is not configured (e.g. local dev with the mock server, or an
  // environment whose SSO client is not provisioned yet) the login guard is
  // bypassed so the CMS stays usable. Once OIDC is configured, a valid token
  // (or a refresh token to obtain one) is required.
  if (!isOidcConfigured || hasSession()) {
    return <Outlet />;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
}
